function webviewTrack(name, parameters) {
  return () => {
    // Check if it's iOS WebView
    const isIOSWebView = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        userAgent
      );
      return isIOS && isWebView;
    };

    if (window.AnalyticsWebInterface) {
      // Call Android interface
      window.AnalyticsWebInterface.logEvent(name, parameters);
    } else if (isIOSWebView() && window.webkit?.messageHandlers?.firebase) {
      // Call iOS interface
      const message = { command: 'logEvent', name, parameters };
      window.webkit.messageHandlers.firebase.postMessage(message);
    }
  };
}

const bindTrack = () => {
  const trackedAnchors = Array.from(
    document.querySelectorAll('.webview-track')
  );
  trackedAnchors.forEach((anchor) => {
    const name = anchor.getAttribute('data-name');
    const parameters = anchor.getAttribute('data-parameters');

    if (name && parameters) {
      const trackFunc = webviewTrack(name, parameters);
      anchor.addEventListener('click', trackFunc);
    }
  });
};

if (typeof window !== 'undefined') {
  bindTrack();
}

export { webviewTrack };
